import {
  CloseOutlined,
  FormOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";
import "suneditor/dist/css/suneditor.min.css";

import React, { useContext } from "react";
import { SettingsSections } from "../../Services/SettingService";
import { notificationContext } from "../../Common/PageRoute";
import { useClient } from "../../Context/ClientContext";

const SettingItems = () => {
  const [form] = Form.useForm();
  const { companySettings, updateCompanySettings, currentClient } = useClient();
  const { openNotification } = useContext(notificationContext);
  const [select, setSelect] = React?.useState<{
    value: SettingsSections;
    label: string;
    key: string;
    postNewName?: string;
  }>({
    value: SettingsSections.Invoice,
    label: "TAX INVOICE",
    key: "invoice",
    postNewName: "",
  });

  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);
  const [isEdit, setIsEdit] = React.useState<boolean>(false);
  const [isInventoryManagement, setIsInventoryManagement] =
    React.useState<boolean>(false);
  const [searchQuery, setSearchQuery] = React.useState("");

  React?.useEffect(() => {
    form.setFieldsValue(companySettings?.setting.item);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySettings]);

  const highlightLabel = (label: string) => {
    if (!searchQuery) return label;
    const regex = new RegExp(`(${searchQuery})`, "gi");
    const parts = label.split(regex);

    return (
      <span>
        {parts.map((part, index) => {
          // Highlight the matching part
          if (part.toLowerCase() === searchQuery.toLowerCase()) {
            return (
              <span
                key={index}
                style={{
                  color: "white",
                  backgroundColor: "rgb(106 119 227)",
                }}
              >
                {part}
              </span>
            );
          }
          return <span key={index}>{part}</span>;
        })}
      </span>
    );
  };

  const shouldShowField = (label: string) =>
    label.toLowerCase().includes(searchQuery.toLowerCase());

  return (
    <>
      <div
        style={{
          padding: "5px 5px 5px 5px",
          maxHeight: "100%",
          overflowY: "auto",
        }}
      >
        {/* <Row gutter={10}>
          <Col span={3} style={{ display: "flex", justifyContent: "flex-end" }}>
            {isEdit ? (
              <></>
            ) : (
              <Tooltip title="Edit">
                <Button
                  style={{
                    marginRight: "10px",
                    padding: "13px 15px",
                    marginTop: "3px",
                  }}
                  type="primary"
                  size="small"
                  icon={<FormOutlined />}
                  onClick={() => {
                    setIsEdit(true);
                  }}
                >
                  Edit
                </Button>
              </Tooltip>
            )}
          </Col>

          <Divider className="my-7" />
        </Row> */}

        <div style={{ maxWidth: "708px", margin: "0 auto" }}>
          <Input
            placeholder="Search settings..."
            prefix={
              <SearchOutlined style={{ color: "#aaa", fontSize: "18px" }} />
            }
            allowClear
            style={{
              padding: "10px 16px",
              fontSize: "16px",
              marginBottom: "10px",
            }}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <Row
          style={{
            margin: "0 auto",
            maxWidth: "720px",
            display: "flex",
            justifyContent: "flex-end",
          }}
          gutter={10}
        >
          <Col span={3} style={{}}>
            {/* {isEdit ? (
              <></>
            ) : ( */}
            {/* <Tooltip title="Edit"> */}
            <Button
              style={{
                marginRight: "10px",
                padding: "13px 15px",
                marginTop: "3px",
              }}
              type="primary"
              size="small"
              icon={<FormOutlined />}
              disabled={isEdit}
              onClick={() => {
                setIsEdit(true);
              }}
            >
              Edit
            </Button>
            {/* </Tooltip> */}
            {/* )} */}
          </Col>
        </Row>
        <div
          style={{
            height: "68vh",
            overflowY: "scroll",
            margin: "0 auto",
            maxWidth: "720px",
            overflowX: "hidden",
          }}
        >
          <Form
            form={form}
            colon={false}
            name="CustomizeSalesInvoice"
            disabled={!isEdit}
            requiredMark={true}
            // labelAlign="left"
            labelCol={{ span: 7 }}
            // wrapperCol={{ span: 1 }}
            // layout="inline"
            labelAlign="left"
            initialValues={{
              start: "001",
              separator: "-",
            }}
          >
            <>
              <div
                style={{
                  padding: "15px",
                  // marginTop: "10px",
                  // maxHeight: "1000px",
                  // overflowY: "auto",
                  position: "relative",
                }}
              >
                {/* --------- Item Setting --------- */}

                <div style={{ maxWidth: "700px", margin: "0 auto" }}>
                  {/* Prefix / Suffix */}
                  <div
                    className={
                      shouldShowField("Prefix / Suffix") ? "" : "hidden"
                    }
                  >
                    <Form.Item
                      name="isSuffix"
                      className="m-0"
                      label={highlightLabel("Prefix / Suffix")}
                    >
                      <Select
                        className="custom-select small-font-select"
                        placeholder="Select"
                        options={[
                          { value: false, label: "Prefix" },
                          { value: true, label: "Suffix" },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  {/* Prefix / Suffix Text */}
                  <div
                    className={
                      shouldShowField("Prefix / Suffix Text") ? "" : "hidden"
                    }
                  >
                    <Form.Item
                      name="preSuf"
                      className="m-0"
                      label={highlightLabel("Prefix / Suffix Text")}
                      rules={[
                        {
                          min: 2,
                          max: 10,
                          message: "The maximum length is 10 characters only",
                        },
                      ]}
                    >
                      <Input
                        minLength={2}
                        maxLength={10}
                        className="custom-input small-font-input"
                      />
                    </Form.Item>
                  </div>
                  {/* Start from */}
                  <div
                    className={shouldShowField("Start from") ? "" : "hidden"}
                  >
                    <Form.Item
                      name="start"
                      className="m-0"
                      label={
                        <Tooltip title="Minimum text padding is 3 i.e. if you provide '1' it will be shown as '001' and if you provide '00001' then text padding will be automatic to 5">
                          {highlightLabel("Start from")}
                        </Tooltip>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please input start number",
                        },
                      ]}
                    >
                      <Input
                        minLength={3}
                        maxLength={6}
                        className="custom-input small-font-input"
                        onBlur={(
                          e: React.FocusEvent<HTMLInputElement, Element>
                        ) => {
                          if (e.target?.value.length < 3) {
                            form.setFieldValue(
                              "start",
                              e?.target?.value.toString().padStart(3, "0")
                            );
                          }
                        }}
                        onKeyPress={(e) =>
                          !/[0-9]/.test(e.key) && e.preventDefault()
                        }
                      />
                    </Form.Item>
                  </div>
                  {/* Separator */}
                  <div className={shouldShowField("Separator") ? "" : "hidden"}>
                    <Form.Item
                      label={highlightLabel("Separator")}
                      name="separator"
                      className="m-0"
                    >
                      <Select
                        className="custom-select small-font-select"
                        placeholder="Separator"
                        options={[
                          { value: "-", label: "-" },
                          { value: "#", label: "#" },
                          { value: "/", label: "/" },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  {/* Item Category */}
                  <div
                    className={shouldShowField("Item Category") ? "" : "hidden"}
                  >
                    <Form.Item
                      label="Item Category"
                      name="maintainCategory"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div>
                  {/* Item Group */}

                  {/* <div
                    className={shouldShowField("Item Group") ? "" : "hidden"}
                  >
                    <Form.Item
                      label="Item Group"
                      name="maintainItemGroup"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div> */}

                  {/* Inventory Management */}

                  {/* <div
                    className={
                      shouldShowField("Inventory Management") ? "" : "hidden"
                    }
                  >
                    <Form.Item
                      label="Inventory Management"
                      name="inventoryManage"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox
                        onChange={(e) =>
                          setIsInventoryManagement(e.target.checked)
                        }
                      />
                    </Form.Item>
                  </div> */}

                  {/* maintainItemLocation */}
                  {/* {isInventoryManagement && ( */}
                  <div className={shouldShowField("Location") ? "" : "hidden"}>
                    <Form.Item
                      label="Inventory Location"
                      name="maintainItemLocation"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div>
                  {/* )} */}
                  {/* Barcode Scan */}
                  <div
                    className={shouldShowField("Barcode Scan") ? "" : "hidden"}
                  >
                    <Form.Item
                      label="Barcode Scan"
                      name="isBarcode"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div>

                  {/* MRP */}
                  <div className={shouldShowField("MRP") ? "" : "hidden"}>
                    <Form.Item
                      label="MRP"
                      name="isMrp"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div>
                  {/* Wholesale Price */}
                  <div
                    className={
                      shouldShowField("Wholesale Price") ? "" : "hidden"
                    }
                  >
                    <Form.Item
                      label="Wholesale Price"
                      name="wholesalePrice"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div>
                  {/* Batch Tracking */}
                  <div
                    className={
                      shouldShowField("Batch Tracking") ? "" : "hidden"
                    }
                  >
                    <Form.Item
                      label="Batch Tracking"
                      name="batchTracking"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div>
                  {/* Serial No. Tracking */}
                  <div
                    className={
                      shouldShowField("Serial No. Tracking") ? "" : "hidden"
                    }
                  >
                    <Form.Item
                      label="Serial No. Tracking"
                      name="serialTracking"
                      className="m-0"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </div>
                  <Row
                    justify={"end"}
                    style={{
                      marginTop: "20px",
                      bottom: 0,
                    }}
                  >
                    <Col>
                      {isEdit ? (
                        <Space>
                          <Button
                            icon={<CloseOutlined />}
                            onClick={() => {
                              setIsEdit(false);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="primary"
                            icon={<SaveOutlined />}
                            loading={saveButtonLoading}
                            onClick={() => {
                              if (isEdit && select.value) {
                                form.validateFields().then((val: any) => {
                                  setSaveButtonLoading(true);
                                  /** Post
                                   * to add state values in Form Values
                                   */

                                  console.log("New val", val, {
                                    ...companySettings,
                                    setting: {
                                      ...companySettings?.setting!,
                                      item: val,
                                    },
                                  });

                                  const postVal = { item: val };

                                  updateCompanySettings!(
                                    SettingsSections.Item,
                                    {
                                      ...companySettings,
                                      setting: {
                                        ...companySettings?.setting!,
                                        item: val,
                                      },
                                    },
                                    postVal
                                  ).then((result: any) => {
                                    if (result?.status) {
                                      setIsEdit(false);
                                      setSaveButtonLoading(false);
                                      openNotification(
                                        "success",
                                        "Setting updated successfully."
                                      );
                                    } else {
                                      setSaveButtonLoading(false);
                                      openNotification(
                                        "error",
                                        result.message ?? "There is some error."
                                      );
                                    }
                                  });
                                });
                              }
                            }}
                          >
                            Save
                          </Button>
                        </Space>
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </>
          </Form>
        </div>
      </div>
    </>
  );
};

export default SettingItems;
